<script lang="ts" setup>
const props = defineProps({
  show: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <div v-if="props.show">
    <div class="i-svg-spinners-3-dots-scale size-full"></div>
  </div>
</template>

<style lang="scss" scoped>
</style>
